import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import ProfessionalRegister from './pages/ProfessionalRegister';
import HospitalRegister from './pages/HospitalRegister';
import PatientRegister from './pages/PatientRegister';
import PatientDashboard from './pages/PatientDashboard';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import HospitalDashboard from './pages/HospitalDashboard';
import ProfessionalDashboard from './pages/ProfessionalDashboard';
import ProfessionalVisitRequests from './pages/ProfessionalVisitRequests';
import ProfessionalProfile from './pages/ProfessionalProfile';
import HospitalProfile from './pages/HospitalProfile';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminLayout from './pages/admin/AdminLayout';
import AdminHome from './pages/admin/AdminHome';
import AdminPatients from './pages/admin/AdminPatients';
import AdminVisitRequests from './pages/admin/AdminVisitRequests';
import AdminUserRegister from './pages/admin/AdminUserRegister';
import UpdateAdminPassword from './pages/admin/UpdateAdminPassword';
import HospitalPostings from './pages/admin/HospitalPostings';
import PostingByHospitals from './pages/admin/PostingByHospitals';
import RegisteredProfessionals from './pages/admin/RegisteredProfessionals';
import TimeSheetApproval from './pages/admin/TimeSheetApproval';
import AdminQualifications from './pages/admin/AdminQualifications';


function PatientLoginRedirect() {
  const location = useLocation();
  return <Navigate to="/login" replace state={location.state} />;
}

function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <ToastContainer position="top-right" theme="colored" />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/professional-register" element={<ProfessionalRegister />} />
        <Route path="/hospital-register" element={<HospitalRegister />} />
        <Route path="/patient-register" element={<PatientRegister />} />
        <Route path="/patient-login" element={<PatientLoginRedirect />} />
        <Route path="/admin-register" element={<AdminUserRegister />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route element={<ProtectedRoute allowedRoles={['hospital']} />}>
          <Route path="/hospital-dashboard" element={<HospitalDashboard />} />
          <Route path="/hospital-profile" element={<HospitalProfile />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['professional']} />}>
          <Route path="/professional-dashboard" element={<ProfessionalDashboard />} />
          <Route path="/professional-visit-requests" element={<ProfessionalVisitRequests />} />
          <Route path="/professional-profile" element={<ProfessionalProfile />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['patient']} loginPath="/login" />}>
          <Route path="/patient-dashboard" element={<PatientDashboard />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route element={<AdminLayout />}>
            <Route path="/admin/dashboard" element={<AdminHome />} />
            <Route path="/admin/patients" element={<AdminPatients />} />
            <Route path="/admin/visit-requests" element={<AdminVisitRequests />} />
            <Route path="/admin/hospitals" element={<AdminDashboard />} />
            <Route path="/admin/qualifications" element={<AdminQualifications />} />
          </Route>
          <Route path="/admin/update-password" element={<UpdateAdminPassword />} />
          <Route path="/admin/hospital-postings/:id" element={<HospitalPostings />} />
          <Route path="/admin/posting-by-hospitals" element={<PostingByHospitals />} />
          <Route path="/admin/registered-professionals" element={<RegisteredProfessionals />} />
          <Route path="/admin/time-sheet-approval" element={<TimeSheetApproval />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
